(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('modelTabWorkflow', modelTabWorkflow);

    modelTabWorkflow.$inject = ['$q', '$log', '_', 'mainWorkspace', 'modelProcessingWorkflow', 'modelService',
        'modelFilePreviewService', 'modelViewerService', 'productFactory', 'productSalesPriceProvider'];

    function modelTabWorkflow($q, $log, _, mainWorkspace, modelProcessingWorkflow, modelService,
        modelFilePreviewService, modelViewerService, productFactory, productSalesPriceProvider) {

        var views = {
            browseModel: 'browse-model',
            fileUploading: 'file-uploading',
            modelProcessing: 'model-processing',
            modelViewer: 'model-viewer'
        };

        var abortMainFlow = null;

        var tabWorkflow = {
            init: init,
            getViewName: getViewName,
            fileSelected: fileSelected,
            selectModel: selectModel,
            abortAndSelectModel: abortAndSelectModel,
            refresh: refresh,

            abortAndResetState: abortAndResetState
        };

        return tabWorkflow;

        // ------------------------------------------------------------------------------------------------------------------------
        // -----------------------------------------------------PUBLIC METHODS ----------------------------------------------------
        // ------------------------------------------------------------------------------------------------------------------------

        function init() {
            $log.debug('ModelTab workflow: initializing...');

            if (mainWorkspace.product.model.id) {
                selectModel(mainWorkspace.product.model.id);
            }

            $log.debug('ModelTab workflow: initializing done.');
        }

        function getViewName() {
            if (mainWorkspace.fileToShowDirectly) {
                return views.modelViewer;
            }

            var model = mainWorkspace.product.model;
            switch (model.state) {
                case 'FileUploading':
                    return views.fileUploading;

                case 'GettingModelInfo':
                    if (model.uploadingFilePercentage !== null) {
                        return views.modelProcessing;
                    }

                    return views.modelViewer;

                case 'ModelCreating':
                case 'WaitProcessingResult':
                    return views.modelProcessing;

                case 'Complete':
                    return views.modelViewer;

                default:
                    if (model.id) {
                        return views.modelViewer;
                    }

                    return views.browseModel;
            }
        }

        function fileSelected(file) {
            $log.debug('fileSelected name=' + file.name);

            mainWorkspace.issue = null;

            if (modelViewerService.canBeShowDirectly(file)) {
                mainWorkspace.fileToShowDirectly = file;
            } else {
                mainWorkspace.fileToShowDirectly = null;
            }

            runMainFlow(file);
        }

        function selectModel(modelId) {
            $log.debug('selectModel id=' + modelId);

            mainWorkspace.issue = null;
            mainWorkspace.fileToShowDirectly = null;

            modelService.getModelProductTemplateId(modelId)
                .then(function (productTemplateId) {
                    mainWorkspace.product.productTemplateId = productTemplateId;
                    $log.debug("Set productTemplateId to product by model. productTemplateId=" + productTemplateId + " modelId=" + modelId);

                    runMainFlow(modelId);
                })
                .catch(function (reason) {
                    mainWorkspace.product.model.id = null; // will show browse button
                    mainWorkspace.product.productTemplateId = mainWorkspace.options.productTemplateId; // will show materials for default product templates

                    throw new Upload3DModelGeneralError('Getting product template id for model is failed.', reason);
                });
        }

        function abortAndSelectModel(modelId) {
            abortAndResetState();

            // Reset product template for new product. Product template will be initialized from server by modelId. 
            // Otherwise materials and permissions will be checked twice. For PT of current site and for PT of model.
            mainWorkspace.product.productTemplateId = null;

            selectModel(modelId);
        }

        function refresh() {
            var model = mainWorkspace.product.model;

            if (model.id) {
                model.result = null;
                productSalesPriceProvider.clearCache();
                selectModel(model.id);
            }
        }

        function abortAndResetState() {
            $log.debug('abortAndResetState');

            if (abortMainFlow) {
                abortMainFlow();
            }

            mainWorkspace.product = productFactory.createDefault(mainWorkspace.options.productTemplateId);
            mainWorkspace.fileToShowDirectly = null;
            mainWorkspace.issue = null;
            mainWorkspace.options.viewer.clipping = false;
            mainWorkspace.options.viewer.cameraPosition = null;
        }

        // --------------------------------------------------- Private functions -------------------------------------------------------------

        function runMainFlow(initialState) {
            if (abortMainFlow) {
                abortMainFlow();
            }

            var cancelerDeferred = $q.defer();
            abortMainFlow = function () {
                $log.debug('abortMainFlow');
                cancelerDeferred.resolve();
            };

            var tasks =
                [
                    processModelTask,
                    getPreviewInfoTaskAsync
                ];

            var self = this;
            var flow = $q.resolve(initialState);
            _.each(tasks, function (task) {
                flow = flow.then(function (result) {
                    return task.call(self, result, cancelerDeferred.promise);
                });
            });

            flow = flow.finally(function () {
                $log.debug('FINISHED model tab workflow');

                mainWorkspace.product.state = 'Ready';

                cancelerDeferred.reject();
                abortMainFlow = null;
            });

            flow = flow.catch(function (reason) {
                if (reason === 'CANCELED') {
                    mainWorkspace.product.state = 'Draft';
                    return;
                }

                mainWorkspace.product.model.previewInfo = null;
                // Direct shown file should not be hidden
                // mainWorkspace.fileToShowDirectly = null;

                $log.debug('Model tab workflow failed. Reason: ', reason);
            });

            return flow;
        }

        // ---------------------------------------- processModelTask -------------------------------------

        function errorExeption(message) {
            this.message = message;
        }

        function processModelTask(initialState, canceler) {
            $log.debug('processModelTask initialState = ', initialState);

            mainWorkspace.product.state = 'ModelProcessing';

            var processingWorkflowInstance = new modelProcessingWorkflow.Instance(mainWorkspace.product.model, {});

            if (angular.isString(initialState)) {
                var modelId = initialState;
                return processingWorkflowInstance.processModel(modelId, canceler)
                    .catch(handleBadModel);
            }

            if (angular.isObject(initialState)) {
                var file = initialState;
                return processingWorkflowInstance.processFile(file, mainWorkspace.options.units, mainWorkspace.product.productTemplateId, canceler)
                    .catch(handleBadModel);
            }

            throw new errorExeption('Invalid type of initialState.');
        }

        function handleBadModel(reason) {
            var model = mainWorkspace.product.model;
            
            // Need skip exception for show stripe when model invalid.
            if (model.issue && model.result && model.result.isInvalid()) {
                return $q.resolve(model);
            }

            // Need skip exception for show stripe when model fixed by V3.
            if (model.issue && model.issue.isQuestion()) {
                return $q.resolve(model);
            }

            return $q.reject(reason);
        }

        // ---------------------------------------- getPreviewInfoTaskAsync -------------------------------------

        function getPreviewInfoTaskAsync(model, canceler) {
            var result = model ? model.result : null;
            if (!result) {
                return $q.reject('Retrieve preview info failed. No processing results.');
            }

            if (mainWorkspace.fileToShowDirectly && !model.hasBeenFixed) {
                return $q.resolve(model);
            }

            if (!model.previewInfo && (result.isSucceeded() || result.isInvalid())) {
                getModelPreviewInfo(model, canceler);
            }

            return $q.resolve(model);
        }

        function getModelPreviewInfo(model, canceler) {
            $log.debug('getPreviewInfoAsync modelId = ' + model.id);

            model.isPreviewGenerating = true;
            model.isPreviewGeneratingFailed = false;

            get3DPreviewInfo(model.id, canceler)
                .then(function (previewInfo) {
                    if (previewInfo !== null) {
                        return previewInfo;
                    }

                    return getStripePreviewInfo(model.id, canceler);
                })
                .then(function (previewInfo) {
                    $log.debug('Set previewInfo for modelId = ' + model.id, previewInfo);

                    // Set camera position for fixed model.
                    mainWorkspace.options.viewer.cameraPosition = modelViewerService.getCameraPosition();
                    model.previewInfo = previewInfo;
                })
                .catch(function () {
                    model.isPreviewGeneratingFailed = true;
                    model.previewInfo = null;

                    $log.debug('Can not retrieve preview info for modelId = ' + model.id);
                })
                .finally(function () {
                    model.isPreviewGenerating = false;
                });
        }

        function get3DPreviewInfo(modelId, canceler) {
            if (!modelViewerService.isWebGlSupported()) {
                return $q.resolve(null);
            }

            return modelFilePreviewService.get3DPreviewInfo(modelId, canceler)
                .then(function (previewInfo) {

                    if (modelViewerService.canBeShownBy3DViewer(previewInfo)) {
                        return previewInfo;
                    }

                    return null;
                });
        }

        function getStripePreviewInfo(modelId, canceler) {
            return modelFilePreviewService.getStripePreviewInfo(modelId, canceler);
        }
    }
}());